import { AppState } from 'src/application/state';
import { initialState, SecShortData } from './reducer';

export const getSecShortIsModuleLoaded = (
  state: AppState,
): boolean => (
  state.secShort
    ? state.secShort.isModuleLoaded
    : initialState.isModuleLoaded
);

export const getSecShortData = (
  state: AppState,
): SecShortData => (
  state.secShort
    ? state.secShort
    : initialState
);
